// Note: Constants for the project
import { ModelFormatTypeEnum } from "../../enums/models.enum";
import {
  API_RESPONSE_MODEL,
  ROUTES_MODEL,
  TOKENS_MODEL,
} from "../Models/ConstantModels";

const ROUTES: ROUTES_MODEL = {
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  WORK_BENCH: "/workbench",
  VIEWMODELS: "/viewModels",
  VERIFY_LOGIN: "/verify-login/:token",
  CHAT_CONTENT: "/generate-content/:id",
  CHAT_CONTENT_INITIAL: "/generate-content",
  COPILOT: "/copilot",
  QUERYLIST: "/querylist",
  SEMANTIC_MODEL: "/semantic-model",
  PINBOARD: "/pinboard",
};

const TOKENS: TOKENS_MODEL = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  CONNECTION_ID: "connectionID",
  SEMANTIC_SECRET_KEY: 'semanticSecretKey',
  MODEL_COMPLETED: "modelCompleted"
};

const API_RESPONSE: API_RESPONSE_MODEL = {
  STATUS: "status",
  TRUE: true,
  FALSE: false,
  NULL: null
};

const fileConfigs = {
  image: {
    maxSizeInMB: 5,
    minSizeInKB: 1,
    acceptedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
  },
  document: {
    maxSizeInMB: 10,
    acceptedTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  },
  video: {
    maxSizeInMB: 100,
    acceptedTypes: ['video/mp4', 'video/mpeg', 'video/quicktime', 'video/mkv', 'video/avi']
  }
};

const uploadNodeConfig = {
  ...fileConfigs.image,
  acceptedTypes: ['image/jpeg', 'image/png', 'application/pdf'],
  maxSizeInMB: 10,
  allowedExtensions: ['.jpg', '.jpeg', '.png', '.pdf']
};

type TableItem = {
  tableName: string;
  columns: string[];
  isAllColumnsSelected: boolean;
};

const featureStatusMap: any = {
  default: [
    "Data collection",
    "Data Extraction",
    "Embedding model creation",
    "Finishing it up",
  ],
  [ModelFormatTypeEnum.CSV]: [
    "Data collection",
    "Data Extraction",
    "Embedding model creation",
    "Finishing it up",
  ],
  [ModelFormatTypeEnum.FLOW_DIAGRAM]: [
    "Data collection",
    "Data Extraction",
    "Embedding model creation",
    "Finishing it up",
  ],
  [ModelFormatTypeEnum.WEB_LINK]: [
    "Collecting Links",
    "Extracting text from the links",
    "Indexing Extracted Text",
    "Embedding model creation",
    "Finishing it up with Prompt",
  ],
};

const processStatusColorMap: any = {
  Completed: { dotColor: "green", textColor: "#3FB870" },
  Failure: { dotColor: "red", textColor: "#ff5c5e" },
  "In-Progress": { dotColor: "#1677ff", textColor: "#54c3ff" },
  Pending: { dotColor: "gray", textColor: "gray" },
  Loading: { dotColor: "gray", textColor: "gray" },
};

const ALLOWED_MODEL_FILE_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv'
];

const MAX_MODEL_FILE_SIZE = 5 * 1024 * 1024;

const SSC_BASE_URL: string = 'https://sse-stg.meii.ai/subscribe/';


export { ROUTES, TOKENS, API_RESPONSE, uploadNodeConfig, featureStatusMap, processStatusColorMap, fileConfigs, ALLOWED_MODEL_FILE_TYPES, MAX_MODEL_FILE_SIZE, SSC_BASE_URL };

export const databaselist = [
  { label: 'MYSQL', value: 'mysql' },
  // { label: 'MONGO_DB', value: 'mongodb' },
  // { label: 'POSTGRESQL', value: 'postgresql' }
]

export function generateSQLQuery(table: string, tableItem: TableItem): string {
  const { tableName: itemTable, columns, isAllColumnsSelected } = tableItem;

  if (table !== itemTable) {
    throw new Error("Table names do not match.");
  }

  const columnPart = isAllColumnsSelected ? "*" : columns.join(", ");
  return `SELECT ${columnPart} FROM ${table};`;
}

